/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_NInputs */

const en_tut_draf_n = /** @type {(inputs: Tut_Draf_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This draft is private to the host — other members never see it. It does not replace the notes, does not create issues, and does not send anything. Limit: 3 attempts per meeting per hour. If the transcript changes after a draft is made, the draft is marked stale and should be regenerated.`)
};

const id_tut_draf_n = /** @type {(inputs: Tut_Draf_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf ini privat untuk host — anggota lain tidak melihatnya. Ia tidak menggantikan Catatan, tidak membuat issue, dan tidak mengirim apa pun. Batas: 3 percobaan per rapat per jam. Kalau transkrip berubah setelah draf dibuat, draf ditandai basi dan sebaiknya dibuat ulang.`)
};

/**
* | output |
* | --- |
* | "This draft is private to the host — other members never see it. It does not replace the notes, does not create issues, and does not send anything. Limit: 3 a..." |
*
* @param {Tut_Draf_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_n = /** @type {((inputs?: Tut_Draf_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_n(inputs)
	return en_tut_draf_n(inputs)
});